import { TranslatedString } from "@ct-react/core";

export type Asset = {
  url: string;
  breakpoint?: "SM" | "MD" | "LG";
}

type Media = {
  title?: TranslatedString;
  alternativeText?: TranslatedString;
}

export type Image = {
  main: boolean;
  aspectRatio: string;
  assets: Asset[];
} & Media;

export type ExternalMedia = {
  url: string;
} & Media;

export type Document = {
  mimeType?: string;
} & ExternalMedia;

export type AnyMedia = Image | ExternalMedia | Document;

export const isImageMedia = (media: AnyMedia): media is Image => "assets" in media;
